module.exports = __webpack_public_path__ + "img/icon-list.553291d1.svg";